import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './Component_SideNavBar.scss';
import { _className, ComponentSync, ModuleFE_RoutingV2, openContent, TS_NavLink } from '@nu-art/thunderstorm-frontend/index';
import { ICONS } from '@app/styles';
import { _values } from '@nu-art/ts-common';
import { ModuleFE_AppModule, RouteDomainsMap } from '../../../modules/app-module/ModuleFE_AppModule.js';
export class Component_SideNavBar extends ComponentSync {
    constructor(p) {
        super(p);
    }
    __onSessionUpdated() {
        this.forceUpdate();
    }
    deriveStateFromProps() {
        return {
            routeKey: ModuleFE_RoutingV2.getCurrentRouteKey()?.key,
            sideNavBarIsOpen: ModuleFE_AppModule.getNavBarStatus()
        };
    }
    __onToggleSideNavBarState() {
        this.setState({ ...this.state, sideNavBarIsOpen: ModuleFE_AppModule.getNavBarStatus() });
    }
    render() {
        return _jsx("div", { className: _className('knowledge-manager__side-nav-bar unselectable', this.state.sideNavBarIsOpen ? 'open' : undefined), children: _values(RouteDomainsMap)
                .filter(route => route.route.enabled?.() ?? true)
                .map((item) => {
                return this.renderNavBarItem(item);
            }) });
    }
    renderNavBarItem(item) {
        const Icon = ICONS[item.icon];
        return _jsxs(TS_NavLink, { route: item.route, ignoreClickOnSameRoute: true, className: ({ isActive }) => _className('side-nav-bar__nav-item', isActive ? 'selected' : undefined, item.designator && 'show-designator'), ...(!this.state.sideNavBarIsOpen && openContent.tooltip.right('nav-bar-label-tooltip', () => item.routeTitle, { offset: 10 })), children: [_jsx(Icon.component, { "data-designator": item.designator }), _jsx("div", { className: 'side-nav-bar__nav-item__label', children: item.routeTitle })] }, item.route.key);
    }
}
